export const MAX_BOM_WAREHOUSES = 50;
export const MAX_BOM_WAREHOUSES_MESSAGE = `A BOM can have at most ${MAX_BOM_WAREHOUSES} warehouses.`;
export const MAX_BOM_ITEM_GROUP_MEMBERS = 50;
export const MAX_BOM_ITEM_GROUP_MEMBERS_MESSAGE = `An option group can have at most ${MAX_BOM_ITEM_GROUP_MEMBERS} members.`;
export const MAX_BOM_ITEM_GROUP_WAREHOUSES = 50;
export const BOM_ITEM_GROUP_MEMBER_FLOOR = 2;
export const BOM_ITEM_GROUP_MEMBER_FLOOR_MESSAGE = 'An option group needs at least 2 members — delete the group instead.';
// Matches reorderBomInstructions' own 500-entry cap on a single BOM's array payload.
export const MAX_BOM_ITEMS = 500;
export const MAX_BOM_ITEMS_MESSAGE = `A BOM can have at most ${MAX_BOM_ITEMS} recipe items.`;
export const MAX_BOM_ITEM_GROUPS = 100;
export const MAX_BOM_ITEM_GROUPS_MESSAGE = `A BOM can have at most ${MAX_BOM_ITEM_GROUPS} option groups.`;
export const MAX_BOM_DEFAULT_FOR_PARTS = 500;
export const MAX_BOM_DEFAULT_FOR_PARTS_MESSAGE = `A BOM can default for at most ${MAX_BOM_DEFAULT_FOR_PARTS} parts.`;
export const BOM_CONSTRAINTS = {
    num: { maxLength: 70, label: 'BOM name' },
    description: { maxLength: 252, label: 'Description' },
    brand: { label: 'Brand' },
    note: { maxLength: 4000, label: 'Note' },
    url: { maxLength: 256, label: 'URL' },
};
export const BOM_ITEM_CONSTRAINTS = {
    name: { maxLength: 256, label: 'Line name' },
};
export const BOM_INSTRUCTION_CONSTRAINTS = {
    name: { maxLength: 256, label: 'Step name' },
    description: { maxLength: 256, label: 'Description' },
};
export const BOM_ITEM_GROUP_CONSTRAINTS = {
    name: { maxLength: 70, label: 'Group name' },
    prompt: { maxLength: 256, label: 'Prompt' },
};
//# sourceMappingURL=constraints.js.map